/** Uppercase the first character of a value's string form; "" for nullish. */
export const capitalize = (value: unknown): string => {
  if (!value) return ""
  const str = value.toString()
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/** Title-Case a snake_case value as a human label: "on_hold" -> "On Hold". */
export const formatSnakeCase = (value: string | number): string => {
  const s = String(value)
  if (!s) return ""
  return s.replace(/_/g, " ").split(" ").map(capitalize).join(" ")
}
